<template>
    <review-main @back="goBack">
        <template slot="nav">
            <div class="reviewNav">
                <p>资质审核</p>
            </div>
        </template>
        <template slot="main">
            <div class="reviewMain">
                <router-link to="/system/qualification">
                   <div class="qualification_review review">
                       资格审核
                   </div>
                </router-link>
                <router-link to="/system/confirmInfo">
                    <div class="info_review review">
                        信息确认
                    </div>
                </router-link>
            </div>
        </template>
    </review-main>
</template>

<script>

    export default {
        name: "review",
        components:{
            "review-main": () => import("@/components/LayOut/Common/up-down")
        },
        methods:{
            goBack(){
                this.$router.push('/system/sm');
            }
        }
    }
</script>

<style scoped lang="stylus">
@import '~@/assets/css/variable'
.reviewNav, .reviewMain
    flex 1 1 auto
    height 100%
.reviewNav
    display flex
    align-items center
    font-size $font_size_big
.reviewMain
    width 100%
    display flex
    justify-content space-around
    align-items center
    background-color $block_bg_color_base
    .review
        font-size 24px
        cursor pointer
        width 250px
        height 250px
        display flex
        background rgba(0,0,0,0.5)
        align-items center
        justify-content center

</style>
